// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Build the assistant-bubble content shown when the SSE stream errors mid-flight.
 *
 * Regression guard for the 2026-06-10 incident: the previous behavior REPLACED the whole
 * bubble with a generic apology, which destroyed already-received content — including the
 * async image job's status URL — so the generated image (which the backend successfully
 * produced) could never be displayed. Streamed content must be preserved; the error is
 * appended as a notice instead.
 *
 * @param partialContent - Whatever the stream delivered before the error (may be empty).
 * @returns The content to show: preserved partial content + warning, or a standalone
 *   apology when nothing was received at all.
 */
export function buildStreamErrorContent(partialContent: string): string {
  const notice =
    "⚠️ 通信が途中で切れました。表示済みの内容はここまで確定しており、" +
    "実行済みの処理（登録・生成など）は取り消されていません。" +
    "続きが必要な場合はもう一度お試しください。"
  if (partialContent && partialContent.trim()) {
    return `${partialContent}\n\n${notice}`
  }
  return "申し訳ございませんが、処理中にエラーが発生しました。もう一度お試しください。"
}
